let config;

switch (process.env.REACT_APP_CONFIG_ENV) {
  case "dev":
    config = require("./config.dev").default;
    break;
  case "prod":
    config = require("./config.prod").default;
    break;
  default:
    throw new Error("Invalid REACT_APP_CONFIG_ENV value");
}

export default config;